/**
 * Simple gesture helpers. No Hammer.js dependency — these are < 20 lines
 * and cover the specific interactions we need (double-tap, long-press).
 */

export function createDoubleTapHandler(callback: () => void, thresholdMs = 300): () => void {
  let lastTap = 0;
  return () => {
    const now = Date.now();
    if (now - lastTap < thresholdMs) {
      callback();
      lastTap = 0;
    } else {
      lastTap = now;
    }
  };
}
